import { createSelector } from 'reselect';

import { getCompany } from './company.selectors';

export const selectCompanyAuthMethodConfig = createSelector(
  getCompany,
  ({ authMethodConfig }) => authMethodConfig,
);
